import { AxiosRequestConfig } from "axios";
import api from "./api";

interface targetData {
    name?: string;
    locations?: any;
    cards?: any;
}

const prefix = "target-audience";

const targetService = {
    list: (config?: AxiosRequestConfig) => api.get(`/${prefix}`, config),
    store: (data: targetData) => api.post(`/${prefix}`, data),
    update: (id: number | string, data: targetData) => api.put(`/${prefix}/${id}`, data),
    get: (id: number | string) => api.get(`/${prefix}/${id}`),
    destroy: (id: number | string) => api.delete(`/${prefix}/${id}`),
};

export default targetService;
